import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M45 22.5H14.8V5.4H45v17.1zM17.3 20h25.2V7.9H17.3V20z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M11.6 22.5H0V5.4h11.6v17.1zM2.5 20h6.6V7.9H2.5V20z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 45H0V25.1h22.5V45zm-20-2.5H20V27.6H2.5v14.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M43.8 38.1L34.7 29l-.9-.9-2 2-2.7-2.7c2.5-2.9 4-6.7 4-10.8C33.2 7.4 25.8 0 16.6 0S0 7.4 0 16.6c0 9.2 7.4 16.6 16.6 16.6 4.1 0 7.9-1.5 10.8-4l2.7 2.7-2 2 9.9 9.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2 1.6-1.6 1.6-4.1 0-5.7zm-27.2-7.4c-7.8 0-14.1-6.3-14.1-14.1S8.8 2.5 16.6 2.5s14.1 6.3 14.1 14.1-6.3 14.1-14.1 14.1zM42 42c-.6.6-1.6.6-2.2 0l-8.2-8.2 2.2-2.2 8.2 8.2c.6.7.6 1.6 0 2.2z"
		})
	]
});
export default SvgIcon;
